/* global toastr */
import ui from '@/config/ui';

const Toast = (type, msg, pos, durationMs) => {
  // Set default position if not provided
  const position = pos || ui.toastPosition || "right";

  // Set timer based on type
  const timer = typeof durationMs === 'number' ? durationMs : (ui.toastDurationMs ?? 5000);

  // Configure toastr options
  toastr.clear(); // clear existing toasts to avoid stacking duplicates
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-" + position,
    preventDuplicates: true,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: timer,
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };

  // Show the toast message (message is the first argument in toastr)
  toastr[type](msg);
};

export default Toast;
